import { PortOvertimeLevel } from '../enums/port-overtime-level.enum';
import { PortCallOvertimeSegment } from './port-call-overtime-segment.model';

// Presentation-only summary of a PortCall's overtime segments, as returned
// by the voyage summary endpoint. Levels/hours are computed server-side —
// this model only converts minutes to hours for display.
export class PortCallOvertimeSnapshotModel {
  public segments: PortCallOvertimeSegment[] = [];

  constructor(
    public effectiveStart?: string | null,
    public effectiveEnd?: string | null,
    public timezone?: string | null,
    public regularMinutes?: number | null,
    public ot1Minutes?: number | null,
    public ot2Minutes?: number | null,
    public highestLevel?: PortOvertimeLevel | string | null
  ) { }

  public fromJSON(json: any): PortCallOvertimeSnapshotModel {
    if (json) {
      this.effectiveStart = json.effectiveStart ?? null;
      this.effectiveEnd = json.effectiveEnd ?? null;
      this.timezone = json.timezone ?? null;
      this.regularMinutes = json.regularMinutes ?? 0;
      this.ot1Minutes = json.ot1Minutes ?? 0;
      this.ot2Minutes = json.ot2Minutes ?? 0;
      this.highestLevel = json.highestLevel ?? null;
      this.segments = Array.isArray(json.segments)
        ? json.segments.map((segment: any) => ({
            level: segment.level,
            hours: Number(segment.hours ?? 0),
            reasons: Array.isArray(segment.reasons) ? segment.reasons : [],
          }))
        : [];
    }

    return this;
  }

  public get hasReasonDetail(): boolean {
    return this.segments.length > 0;
  }

  public get regularHours(): number {
    return (this.regularMinutes ?? 0) / 60;
  }

  public get ot1Hours(): number {
    return (this.ot1Minutes ?? 0) / 60;
  }

  public get ot2Hours(): number {
    return (this.ot2Minutes ?? 0) / 60;
  }
}
